import { useEffect, useState } from 'react'
import { useEligibleManagers } from '../hooks/useEligibleManagers'

export interface HandoffModalProps {
  open: boolean
  onClose: () => void
  onSubmit: (toSupervisorUserId: number) => void
  isSubmitting: boolean
}

export function HandoffModal({ open, onClose, onSubmit, isSubmitting }: HandoffModalProps): JSX.Element | null {
  const { data: managers, isLoading } = useEligibleManagers()
  const [targetId, setTargetId] = useState('')

  useEffect(() => {
    if (!open) return
    function onKey(e: KeyboardEvent): void { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" aria-hidden="true" />
      <div className="relative w-full max-w-md rounded-xl bg-white p-6">
        <h3 className="mb-2 text-lg font-semibold text-gray-900">Hand off shift</h3>
        <p className="mb-4 text-sm text-gray-500">The supervisor notes on this shift carry over to the incoming manager.</p>
        <label htmlFor="handoff-target" className="mb-1 block text-sm font-medium text-gray-700">Hand off to</label>
        <select
          id="handoff-target"
          value={targetId}
          onChange={(e) => setTargetId(e.target.value)}
          className="mb-4 w-full rounded-lg border border-gray-200 p-2 text-sm"
        >
          <option value="" disabled>{isLoading ? 'Loading managers…' : 'Select a manager'}</option>
          {(managers ?? []).map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
        </select>
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="rounded-lg border border-gray-200 px-4 py-2 text-sm">Cancel</button>
          <button
            type="button"
            disabled={!targetId || isSubmitting}
            onClick={() => onSubmit(Number(targetId))}
            className="rounded-lg bg-brand-green px-4 py-2 text-sm font-semibold text-white disabled:opacity-60"
          >
            Send Handoff
          </button>
        </div>
      </div>
    </div>
  )
}
